import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import {
  Dropdown,
} from 'semantic-ui-react';

import _ from 'lodash';
import { compose } from 'recompose';

import hasUserInfo from '../../hocs/has-user-info';
import hasRESTClient from '../../hocs/has-rest-client';

const shopifyUrl = 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production/mefitpro/shopify/discountcodes';

class DiscountCodesSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      selectedDiscountCode: '',
      isLoading: false,
    };
  }

  selectedDiscountCode = selectedDiscountCode => {
    const { onSelected } = this.props;
    onSelected(selectedDiscountCode);
    this.setState({ selectedDiscountCode });
  }

  async componentDidMount() {
    const response = await axios.get(shopifyUrl);
    console.log('discount code', response);
    const discountcodes = _.get(response, 'data', []);
    const options = _.map(discountcodes, dc => ({
      key: _.get(dc, 'code'),
      value: _.get(dc, 'code'),
      text: _.get(dc, 'code'),
      onClick: () => this.selectedDiscountCode(_.get(dc, 'code')),
    }));
    this.setState({
      isLoading: false,
      options,
    });
  }

  render() {
    // const { onSelected } = this.props;
    const { options, isLoading, selectedDiscountCode } = this.state;
    return (
      <Dropdown
        text="Select Discount Codes"
        fluid
        loading={isLoading}
        search
        selection
        multiple
        options={options}
        value={selectedDiscountCode}
      />
    );
  }
}

DiscountCodesSelector.propTypes = {
  onSelected: PropTypes.func.isRequired,
};

export default compose(
  hasRESTClient,
  hasUserInfo,
)(DiscountCodesSelector);



/** WEBPACK FOOTER **
 ** ./src/components/discount-codes-selector/index.js
 **/